import { useState, useRef } from "react";
import { StarField, FormInput, Btn, ResponsiveHCaptcha } from "../components/UI";
import { supabase } from "../lib/supabase";

const HCAPTCHA_SITE_KEY = "c142c84c-5e1e-4bfa-8032-f48e0ff29bac";

export default function StaffLoginPage({ setPage, setStaffUser, setUser }) {
  const [email, setEmail]   = useState("");
  const [pass,  setPass]    = useState("");
  const [error, setError]   = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const captchaRef = useRef(null);

  async function handleLogin() {
    setError("");
    if (!captchaToken) { setError("Please complete the CAPTCHA."); return; }
    setLoading(true);

    const { data: authData, error: authErr } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password: pass,
      options: { captchaToken },
    });

    captchaRef.current?.resetCaptcha();
    setCaptchaToken("");

    if (authErr || !authData.user) {
      setError("Invalid credentials. Please check your email and password.");
      setLoading(false);
      return;
    }

    // Check that this user exists in staff_profiles — parents are blocked here
    const { data: profile, error: profileErr } = await supabase
      .from("staff_profiles")
      .select("*")
      .eq("id", authData.user.id)
      .single();

    if (profileErr || !profile) {
      // Check if this is a parent account and redirect them to the parent portal
      const { data: parentProfile } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", authData.user.id)
        .single();

      if (parentProfile) {
        setUser({ ...parentProfile, students: [] });
        setPage("dashboard");
        return;
      }

      await supabase.auth.signOut();
      setError("This account does not have staff access.");
      setLoading(false);
      return;
    }

    if (profile.active === false) {
      await supabase.auth.signOut();
      setError("This account has been deactivated. Please contact an administrator.");
      setLoading(false);
      return;
    }

    setStaffUser(profile);
    setPage("staff");
    setLoading(false);
  }

  return (
    <div className="staff-login" style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:"7rem 2rem 3rem", position:"relative", overflow:"hidden" }}>
      <StarField count={40} />
      <div style={{ background:"rgba(10,13,48,0.9)", border:"1.5px solid rgba(155,92,246,0.3)", borderRadius:28, padding:"2.6rem", maxWidth:420, width:"100%", position:"relative", zIndex:2, backdropFilter:"blur(14px)" }}>
        <div style={{ textAlign:"center", marginBottom:"1.8rem" }}>
          <span style={{ fontSize:"2.2rem" }}>⚡</span>
          <h2 style={{ fontFamily:"'Fredoka One',cursive", fontSize:"1.9rem", marginTop:"0.4rem", color:"#9B5CF6" }}>Staff Login</h2>
          <p style={{ color:"rgba(255,255,255,0.4)", fontSize:"0.84rem", fontWeight:600, marginTop:3 }}>For teachers and administrators only</p>
        </div>

        <div style={{ display:"flex", flexDirection:"column", gap:"0.9rem" }}>
          <FormInput label="Staff Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="staff@marsacademy.io" required onKeyDown={(e) => e.key === "Enter" && handleLogin()} />
          <FormInput label="Password" type="password" value={pass} onChange={(e) => setPass(e.target.value)} placeholder="••••••••" required onKeyDown={(e) => e.key === "Enter" && handleLogin()} />
          <div style={{ background:"rgba(255,255,255,0.04)", border:"1.5px solid rgba(155,92,246,0.2)", borderRadius:14, padding:"0.9rem" }}>
            <ResponsiveHCaptcha ref={captchaRef} sitekey={HCAPTCHA_SITE_KEY} theme="dark" onVerify={(token) => setCaptchaToken(token)} onExpire={() => setCaptchaToken("")} />
          </div>
          {error && <p style={{ color:"#FF6B6B", fontSize:"0.82rem", fontWeight:700 }}>{error}</p>}
          <Btn onClick={handleLogin} variant="purple" style={{ width:"100%" }} disabled={loading || !captchaToken}>
            {loading ? "Signing in…" : "Sign In to Staff Panel →"}
          </Btn>
          <button onClick={() => setPage("home")} style={{ background:"none", border:"none", color:"rgba(255,255,255,0.35)", fontSize:"0.82rem", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>← Back to main site</button>
        </div>
      </div>
    </div>
  );
}
